var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-uni-view',{staticClass:"u-toolbar",on:{"touchmove":function($event){$event.stopPropagation();$event.preventDefault();
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.noop).apply(void 0, arguments)
}}},[_c('v-uni-view',{staticClass:"u-toolbar__cancel__wrapper",attrs:{"hover-class":"u-hover-class"}},[_c('v-uni-text',{staticClass:"u-toolbar__wrapper__cancel",style:({
				color: _vm.cancelColor
			}),on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.cancel).apply(void 0, arguments)
}}},[_vm._v(_vm._s(_vm.cancelText))])],1),(_vm.title)?_c('v-uni-text',{staticClass:"u-toolbar__title u-line-1"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('v-uni-view',{staticClass:"u-toolbar__confirm__wrapper",attrs:{"hover-class":"u-hover-class"}},[_c('v-uni-text',{staticClass:"u-toolbar__wrapper__confirm",style:({
			color: _vm.confirmColor
		}),on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.confirm).apply(void 0, arguments)
}}},[_vm._v(_vm._s(_vm.confirmText))])],1)],1):_vm._e()}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }